import { Layout, Space } from "antd";
import bem from "easy-bem";
import AttrBar from "features/cases/blocks/AttrBar";
import { useIsMobile } from "hooks/useIsMobile";
import React, { useState } from "react";

import type { CaseShellProps } from "../../CaseShell.types";
import "./AttrHeader.css";

const { Header } = Layout;

const cn = bem("attr-header");

type AttrHeaderProps = Pick<
  CaseShellProps,
  | "kind"
  | "setSolsExpanded"
  | "probExpanded"
  | "setProbExpanded"
  | "setCaseExpanded"
  | "caseExpanded"
>;

const AttrHeader: React.FC<AttrHeaderProps> = ({
  kind,
  setSolsExpanded,
  probExpanded,
  setProbExpanded,
  setCaseExpanded,
  caseExpanded = false,
}) => {
  const { isMobile } = useIsMobile();
  const [isMenuVisible, setIsMenuVisible] = useState(!isMobile);
  const [expanded, setExpanded] = useState(false);
  const [expanded2, setExpanded2] = useState(false);

  return (
    <Header
      className={cn({
        mobile: isMobile && !isMenuVisible,
        "mobile-expanded": isMobile && isMenuVisible,
      })}
    >
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex" }}
      >
        <AttrBar
          kind={kind}
          isVisible={isMenuVisible}
          onToggle={(forced) =>
            setIsMenuVisible(forced === undefined ? !isMenuVisible : forced)
          }
          expanded={expanded}
          setExpanded={setExpanded}
          expanded2={expanded2}
          setExpanded2={setExpanded2}
          setSolsExpanded={setSolsExpanded}
          probExpanded={probExpanded}
          setProbExpanded={setProbExpanded}
          setCaseExpanded={setCaseExpanded}
          caseExpanded={caseExpanded}
        />
      </Space>
    </Header>
  );
};

export default AttrHeader;
